import identity from 'lodash/identity'
export default class ToastsService {

  constructor($q, toastr) {
    'ngInject';
    this.$q = $q;
    this.toastr = toastr;
  }

  showSuccessToast(message, title = 'Success!') {
    return this.toastr.success(message, title);
  }

  showErrorToast(message, title = 'Error!') {
    return this.toastr.error(message, title);
  }

  showInfoToast(message, title = 'Information') {
    return this.toastr.info(message, title);
  }

  wrap(data, successMessage, errorMessage) {
    data = this.$q.resolve(data); // make sure it's a promise

    let successFn = identity;
    let errorFn = identity;

    if (successMessage) {
      successFn = () => {
        this.showSuccessToast(successMessage);
      }
    }

    if (errorMessage) {
      errorFn = () => {
        this.showErrorToast(errorMessage);
      }
    }

    return data.then(successFn, errorFn);
  }
}
